import React from "react";

export default function Gallery() {
  const images = [
    "IMG_20250814_142923.jpg",
    "IMG_20250814_142932.jpg"
  ];
  return (
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="text-3xl font-bold text-primary mb-4">Gallery</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`Gallery ${i}`}
            className="rounded-lg shadow"
          />
        ))}
      </div>
    </div>
  );
}